import { render, staticRenderFns } from "./HostingLanding.vue?vue&type=template&id=ab0835d0&"
import script from "./HostingLanding.vue?vue&type=script&lang=ts&"
export * from "./HostingLanding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports